export var pastEducation = [
    {
        "startIndex": 0,
        "noOfRowsToFetch": 0,
        "mapOfAdditinalParams": null,
        "createdBy": "ANONYMOUS",
        "createdOn": 1478306356000,
        "lastUpdatedBy": null,
        "lastUpdatedOn": null,
        "expiryOn": null,
        "createdOnDateForDisplay": "11/05/2016",
        "createdOnDateInDDMmYYYFormat": null,
        "formattedCreatedDateForDisplay": null,
        "formattedUpdatedDateForDisplay": null,
        "pastEducationId": 7,
        "userDetailsId": null,
        "degreeCourse": "B.Tech (Hons)",
        "educationStartDate": 1224662286000,
        "educationEndDate": 1256111886000,
        "isPresent": "N",
        "educationStartDateForDisplay": "October 2008",
        "educationEndDateForDisplay": "October 2009",
        "educationalInstitutionId": {
            "startIndex": 0,
            "noOfRowsToFetch": 0,
            "mapOfAdditinalParams": null,
            "createdBy": null,
            "createdOn": null,
            "lastUpdatedBy": null,
            "lastUpdatedOn": null,
            "expiryOn": null,
            "createdOnDateForDisplay": null,
            "createdOnDateInDDMmYYYFormat": null,
            "formattedCreatedDateForDisplay": null,
            "formattedUpdatedDateForDisplay": null,
            "educationalInstitutionId": 122,
            "educationalInstitutionCode": null,
            "educationalInstitutionFullName": null,
            "educationalInstitutionCampus": null,
            "countryFullName": null,
            "stateFullName": null,
            "cityFullName": null,
            "zipcodeValue": null,
            "eduInsUserDefined": true
        }
    },
    {
        "startIndex": 0,
        "noOfRowsToFetch": 0,
        "mapOfAdditinalParams": null,
        "createdBy": "ANONYMOUS",
        "createdOn": 1478327876189,
        "lastUpdatedBy": null,
        "lastUpdatedOn": null,
        "expiryOn": null,
        "createdOnDateForDisplay": "11/05/2016",
        "createdOnDateInDDMmYYYFormat": null,
        "formattedCreatedDateForDisplay": null,
        "formattedUpdatedDateForDisplay": null,
        "pastEducationId": 23,
        "userDetailsId": null,
        "degreeCourse": "B.Tech (Hons)",
        "educationStartDate": 972221286419,
        "educationEndDate": 1098365286419,
        "isPresent": "N",
        "educationStartDateForDisplay": "October 2000",
        "educationEndDateForDisplay": "October 2004",
        "educationalInstitutionId": {
            "startIndex": 0,
            "noOfRowsToFetch": 0,
            "mapOfAdditinalParams": null,
            "createdBy": null,
            "createdOn": null,
            "lastUpdatedBy": null,
            "lastUpdatedOn": null,
            "expiryOn": null,
            "createdOnDateForDisplay": null,
            "createdOnDateInDDMmYYYFormat": null,
            "formattedCreatedDateForDisplay": null,
            "formattedUpdatedDateForDisplay": null,
            "educationalInstitutionId": 122,
            "educationalInstitutionCode": null,
            "educationalInstitutionFullName": null,
            "educationalInstitutionCampus": null,
            "countryFullName": null,
            "stateFullName": null,
            "cityFullName": null,
            "zipcodeValue": null,
            "eduInsUserDefined": true
        }
    },
    {
        "startIndex": 0,
        "noOfRowsToFetch": 0,
        "mapOfAdditinalParams": null,
        "createdBy": "ANONYMOUS",
        "createdOn": 1478308000000,
        "lastUpdatedBy": null,
        "lastUpdatedOn": null,
        "expiryOn": null,
        "createdOnDateForDisplay": "11/05/2016",
        "createdOnDateInDDMmYYYFormat": null,
        "formattedCreatedDateForDisplay": null,
        "formattedUpdatedDateForDisplay": null,
        "pastEducationId": 21,
        "userDetailsId": null,
        "degreeCourse": "B.Tech (Hons)",
        "educationStartDate": 972201486000,
        "educationEndDate": 1098345486000,
        "isPresent": "N",
        "educationStartDateForDisplay": "October 2000",
        "educationEndDateForDisplay": "October 2004",
        "educationalInstitutionId": {
            "startIndex": 0,
            "noOfRowsToFetch": 0,
            "mapOfAdditinalParams": null,
            "createdBy": null,
            "createdOn": null,
            "lastUpdatedBy": null,
            "lastUpdatedOn": null,
            "expiryOn": null,
            "createdOnDateForDisplay": null,
            "createdOnDateInDDMmYYYFormat": null,
            "formattedCreatedDateForDisplay": null,
            "formattedUpdatedDateForDisplay": null,
            "educationalInstitutionId": 122,
            "educationalInstitutionCode": null,
            "educationalInstitutionFullName": null,
            "educationalInstitutionCampus": null,
            "countryFullName": null,
            "stateFullName": null,
            "cityFullName": null,
            "zipcodeValue": null,
            "eduInsUserDefined": true
        }
    },
    {
        "startIndex": 0,
        "noOfRowsToFetch": 0,
        "mapOfAdditinalParams": null,
        "createdBy": "ANONYMOUS",
        "createdOn": 1478308055000,
        "lastUpdatedBy": null,
        "lastUpdatedOn": null,
        "expiryOn": null,
        "createdOnDateForDisplay": "11/05/2016",
        "createdOnDateInDDMmYYYFormat": null,
        "formattedCreatedDateForDisplay": null,
        "formattedUpdatedDateForDisplay": null,
        "pastEducationId": 22,
        "userDetailsId": null,
        "degreeCourse": "B.Tech (Hons)",
        "educationStartDate": 972201486000,
        "educationEndDate": 1098345486000,
        "isPresent": "N",
        "educationStartDateForDisplay": "October 2000",
        "educationEndDateForDisplay": "October 2004",
        "educationalInstitutionId": {
            "startIndex": 0,
            "noOfRowsToFetch": 0,
            "mapOfAdditinalParams": null,
            "createdBy": null,
            "createdOn": null,
            "lastUpdatedBy": null,
            "lastUpdatedOn": null,
            "expiryOn": null,
            "createdOnDateForDisplay": null,
            "createdOnDateInDDMmYYYFormat": null,
            "formattedCreatedDateForDisplay": null,
            "formattedUpdatedDateForDisplay": null,
            "educationalInstitutionId": 122,
            "educationalInstitutionCode": null,
            "educationalInstitutionFullName": null,
            "educationalInstitutionCampus": null,
            "countryFullName": null,
            "stateFullName": null,
            "cityFullName": null,
            "zipcodeValue": null,
            "eduInsUserDefined": true
        }
    }
];
//# sourceMappingURL=pastEducation.js.map